<form [formGroup]='signInForm'>
  <!-- <div class="form-field ui-g-12 ui-g-nopad">
    <div class="form-label">
      <label translate>label_select_organization</label>
    </div>
    <div class="form-control-c">
      <p-dropdown [style]="{'width': '100%'}" [options]="selectOrganization">
      </p-dropdown>
    </div>
  </div> -->
  <div class="form-field ui-g-12 ui-g-nopad">
    <div class="form-label">
      <label translate>label_enter_email_address</label>
    </div>
    <div class="form-control-c">
      <input autocomplete="off" formControlName="username" class="textbox-border-bottom" type="text" pInputText appTrim
       (keypress)="eventHandler($event)" />
    </div>
    <div class="form-errors"
      *ngIf="signInForm.controls.username.invalid && (signInForm.controls.username.dirty || signInForm.controls.username.touched)">
      <div *ngIf="signInForm.controls.username.errors.required" translate>
        email_required
      </div>
      <div [hidden]="!signInForm.controls.username.errors.maxlength" translate>
        exceed_max_length
      </div>
      <div *ngIf="isEmailInvalid" translate>
        err_invalid_emailId
      </div>
      <div [hidden]="!signInForm.controls.username.errors.pattern" translate>
        err_invalid_emailId
      </div>
    </div>
  </div>

  <div class="form-field ui-g-12 ui-g-nopad">
    <div class="form-label">
      <label translate>label_enter_password</label>
    </div>
    <div class="form-control-c">
      <input autocomplete="off" appNoWhiteSpace pInputText type="{{inputType}}" formControlName="password"
        class="full-width-transperent" (keypress)="eventHandler($event)" />
      <i [ngClass]="!showPassword ? 'fa fa-eye-slash password-visible-icon' : 'fa fa-eye password-visible-icon'"
        aria-hidden="true" (click)="toggleShowPassword()"></i>
    </div>
    <div class="form-errors"
      *ngIf="signInForm.controls.password.errors  && (signInForm.controls.password.dirty || signInForm.controls.password.touched)">
      <div [hidden]="!signInForm.controls.password.errors.required" translate>
        error_password_required
      </div>
      <div [hidden]="!signInForm.controls.password.errors.minlength" translate>
        password_too_short
      </div>
      <div [hidden]="!signInForm.controls.password.errors.maxlength" translate>
        exceed_max_length
      </div>
    </div>
  </div>

  <div class="form-control-c">
    <div class="form-control-c">
      <button pButton label="{{signInLabel}}"  class='sign-in-buttons' type="button" [disabled]='!signInForm.valid'
        (click)="doSignIn()"></button>
    </div>

    <div class="form-control-c">
      <a (click)="onForgotPassword()" class="forgot-password-link"><label translate style="color: #334CBD;" >forgot_password</label></a>
    </div>

  </div>
</form>
